/**
 * 以下所有的时间都是北京时间
 */

// 每月一次活动-常规活动[洛杉矶0点开始]【夏令时：15:00，冬令时：16:00】
var activity_products = {
    "show": 1,  // 总开关, 活动开始后设为1, 结束后设为0
    "start_time": "2025-05-01 15:00:00",  // 可以为0，不为0时必须定义为 YYYY-mm-dd H:i:s 格式
    "end_time": "2025-05-14 15:00:00", // 可以为0，不为0时必须定义为 YYYY-mm-dd H:i:s 格式
    "show_count_down_box": 0, // 是否显示倒计时。通常为0。
    "list": {
      "f11pro2": {
        "variant_price": [
          [459.99, 389.99]
        ]
      },
      "v11pro": {
        "variant_price": [
          [499.99, 469.99]
        ]
      },
      "f11gim2": {
        "variant_price": [
          [399.99, 339.99]
        ]
      },
      "u11mini 4k": {
        "variant_price": [
          [449.99, 419.99]
        ]
      },
      "1561": {
        "variant_price": [
          [119.99, 99.99]
        ]
      },
      "3589": {
        "variant_price": [
          [79.99, 59.99]
        ]
      },
      "1088": {
        "variant_price": [
          [129.98, 89.98],
          [129.99, 89.99],
          [129.99, 129.99],
          [129.99, 129.99]
        ]
      },
      "v998": {
        "variant_price": [
          [69.99, 49.99]
        ]
      },
      "v992": {
        "variant_price": [
          [49.99, 39.99]
        ]
      }
        // "v11": {  // 产品名称，和 product_common_info 的key 对应 
        //   "variant_price": [  // 变体价格, 每一个变体对应一个数组, 没有变体的商品默认本体就是1个变体
        //     [629.99,409.99] // [原价, 折后价]
        //   ]
        // },
        // "v11": {
        //     "variant_price": [
        //         [399.99, 299.99]
        //     ],
        // },
        // "v11minise": {
        //     "variant_price": [
        //         [279.97, 249.97]
        //     ],
        // },
        // "v11pro": {
        //     "variant_price": [
        //         [499.99, 469.99]
        //     ],
        // },
        // "v991": {
        //     "variant_price": [
        //         [119.99, 90.99]
        //     ],
        // },
        // "v992": {
        //     "variant_price": [
        //         [49.99, 39.99]
        //     ],
        // },
        // "f7gb2": {
        //     "variant_price": [
        //         [399.99,339.99],
        //         [479.99,419.99]
        //     ],
        // },
        // "f7minise": {
        //     "variant_price": [
        //         [279.98, 249.98]
        //     ],
        // },
        // "f11gim2": {
        //     "variant_price": [
        //         [399.99,339.99],
        //         [479.99,399.99],
        //         [559.99,449.99]
        //     ],
        // },
        // "f11mini": {
        //     "variant_price": [
        //         [249.99,189.99],
        //         [299.99,239.99]
        //     ],
        // },
        // "f11pro": {
        //     "variant_price": [
        //         [379.99, 269.99]
        //     ],
        // },
        // "f11pro2": {
        //     "variant_price": [
        //         [459.99, 389.99]
        //     ],
        // },
        // "u11mini": {
        //     "variant_price": [
        //         [249.99, 234.99]
        //     ],
        // },
        // "u11mini 4k": {
        //     "variant_price": [
        //         [499.99, 499.99]
        //     ],
        // },
        // "u11pro": {
        //     "variant_price": [
        //         [279.99, 160.99]
        //     ],
        // },
        // "u11s": {
        //     "variant_price": [
        //         [229.99, 169.99]
        //     ],
        // },
        // "g11pro": {
        //     "variant_price": [
        //         [459.99, 389.99]
        //     ],
        // },
        // "rk100": {
        //     "variant_price": [
        //         [299.99, 199.99],
        //         [599.99, 399.99]
        //     ],
        // },
        // "r111": {
        //     "variant_price": [
        //         [29.99, 26.99],
        //         [34.99, 29.99]
        //     ],
        // },
        // "r299": {
        //     "variant_price": [
        //         [299.99, 199.99]
        //     ],
        // },
        // "q150": {
        //     "variant_price": [
        //         [49.99, 32.99]
        //     ],
        // },
        // "1601amp": {
        //     "variant_price": [
        //         [129.97, 114.97],
        //         [129.99, 114.99],
        //         [129.98, 114.98]
        //     ],
        // },
        // "1088": {
        //     "variant_price": [
        //         [129.99, 99.99],
        //         [129.98, 99.98],
        //         // [129.97, 99.97],
        //         // [129.96, 99.96]
        //     ],
        // },
        // "1604": {
        //     "variant_price": [
        //         [69.99, 52.99],
        //     ],
        // },
        // "1661": {
        //     "variant_price": [
        //         [59.99, 44.99],
        //     ],
        // },
        // "2370": {
        //     "variant_price": [
        //         [59.99, 39.99]
        //     ],
        // },
        // "3589": {
        //     "variant_price": [
        //         [69.99, 54.49]
        //     ],
        // },
        // "6088": {
        //     "variant_price": [
        //         [62.99, 34.99],
        //         [62.99, 34.99]
        //     ],
        // },
    },
};

// 7天秒杀-每周秒杀【洛杉矶0点开始】 
var weekly_deal_products = {
    "show": 1,  // 总开关，一般不需要修改
    "start_time": "15:00",  // 开始时间，一般不需要修改 【夏令时：15:00，冬令时：16:00】
    "end_time": "7天后",    // 结束时间，一般不需要修改
    "list": {
        // "10-06": {  // 开始日期
        //     "product": "u11pro",  // 商品名，与 product_common_info 的key 对应
        //     "variant_price": [    // 变体价格, 每一个变体对应一个数组, 没有变体的商品默认本体就是1个变体
        //         [379.88, 265.92], // [原价, 折后价]
        //         [419.88, 293.92]
        //     ],
        // },
        "04-18": {
            "product": "v998",
            "variant_price": [
                [69.99, 53.20]
            ]
        },
        "04-25": {
            "product": "65w",
            "variant_price": [
                [39.98, 33.99],
                [49.99, 42.50],
                [59.99, 51.00]
            ]
        },
      "05-02": {
            "product": "v11",
            "variant_price": [
                [399.99, 288.00],
            ]
        },
      "05-09": {
            "product": "u11s",
            "variant_price": [
                [229.99, 213.90],
            ]
        },
      "05-16": {
            "product": "v998",
            "variant_price": [
                [69.99, 53.20],
            ]
        },
      "05-23": {
            "product": "65w",
            "variant_price": [
                [39.98, 33.98],
                [49.99, 42.50],
                [59.99, 51.00]
            ]
        }
    }
}

// 每日秒杀-12小时秒杀活动【洛杉矶早8到晚8】
var daily_deal_products = {
    "show": 1,  // 总开关, 不需要修改
    "start_time": "23:00:00",  // 开始时间，不需要修改【夏令时：23:00:00，冬令时：24:00:00】
    "end_time": "12小时后",  // 结束时间，不需要修改
    "list": {  // 折扣商品列表，需要经常更新
        // "10-01": {  // 活动日期
        //     "product": "f11gim2",  // 商品名称，与变量 product_common_info 的 key 值对应
        //     "variant_price": [  // 变体价格, 每一个变体对应一个数组, 没有变体的商品默认本体就是1个变体
        //         [579.99, 394.40],  // [原价, 折扣价格]
        //         [679.99, 462.40],  // [原价, 折扣价格]
        //         [739.99, 503.20]   // [原价, 折扣价格]
        //     ]
        // },
        "04-25": {
            "product": "f7minise",
            "variant_price": [
                [249.98, 234.98]
            ]
        },
        "04-26": {
            "product": "g11mini",
            "variant_price": [
                [239.95, 199.95]
            ]
        },
        "04-27": {
            "product": "f7mini",
            "variant_price": [
                [229.98, 214.98]
            ]
        },
        "04-28": {
            "product": "v11mini",
            "variant_price": [
                [229.97, 214.97]
            ]
        },
        "04-29": {
            "product": "q127",
            "variant_price": [
                [69.99,55.99]
            ]
        },
        "04-30": {
            "product": "v992",
            "variant_price": [
                [49.99, 42.99]
             ]
        },
        "05-01": {
            "product": "1604",
            "variant_price": [
              [69.99, 55.99]
            ]
        },
        "05-02": {
            "product": "q150",
            "variant_price": [
              [49.99, 42.99]
            ]
        },
        "05-03": {
            "product": "1661",
            "variant_price": [
              [59.99, 47.99]
            ]
          },
        "05-04": {
            "product": "g11mimi",
            "variant_price": [
              [229.95, 187.95]
            ]
        },
        "05-05": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-06": {
            "product": "v11mimi",
            "variant_price": [
              [229.97, 214.97]
            ]
        },
        "05-07": {
            "product": "1604",
            "variant_price": [
              [69.99, 55.99]
            ]
        },
        "05-08": {
            "product": "q150",
            "variant_price": [
              [49.99, 42.99]
            ]
        },
        "05-09": {
            "product": "1661",
            "variant_price": [
              [59.99, 47.99]
            ]
        },
        "05-10": {
            "product": "1604",
            "variant_price": [
              [69.99, 55.99]
            ]
        },
        "05-11": {
            "product": "f7mimise",
            "variant_price": [
              [249.98, 234.98]
            ]
        },
        "05-12": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-13": {
            "product": "1604",
            "variant_price": [
              [69.99, 55.99]
            ]
        },
        "05-14": {
            "product": "v11mimi",
            "variant_price": [
              [229.97, 214.97]
            ]
        },
        "05-15": {
            "product": "g11mimi",
            "variant_price": [
              [239.95, 199.95]
            ]
        },
        "05-16": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-17": {
            "product": "v11mimi",
            "variant_price": [
              [229.97, 214.97]
            ]
        },
        "05-18": {
            "product": "65w",
            "variant_price": [
                [39.98, 33.98],
                [49.99, 42.50],
                [59.99, 51.00]
            ]
        },
        "05-19": {
            "product": "1561",
            "variant_price": [
              [119.99, 99.99]
            ]
        },
        "05-20": {
            "product": "g11mimi",
            "variant_price": [
              [229.95, 187.95]
            ]
        },
        "05-21": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-22": {
            "product": "q150",
            "variant_price": [
              [49.99, 42.99]
            ]
        },
        "05-23": {
            "product": "f7mimise",
            "variant_price": [
              [249.98, 234.98]
            ]
        },
        "05-24": {
            "product": "g11mimi",
            "variant_price": [
              [239.95, 199.95]
            ]
        },
        "05-25": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-26": {
            "product": "v11mimi",
            "variant_price": [
              [229.97, 214.97]
            ]
        },
        "05-27": {
            "product": "q127",
            "variant_price": [
              [69.99, 55.99]
            ]
        },
        "05-28": {
            "product": "v992",
            "variant_price": [
              [49.99, 42.99]
            ]
        },
        "05-29": {
            "product": "g11mimi",
            "variant_price": [
              [239.95, 199.95]
            ]
        },
        "05-30": {
            "product": "f7mimi",
            "variant_price": [
              [229.98, 214.98]
            ]
        },
        "05-31": {
            "product": "v11mimi",
            "variant_price": [
              [229.97, 214.97]
            ]
        },
    }
};

var product_common_info = {
    "f11gim2": {  // 自定义的 key
        "id": "7399473217705",   // shopify定义的商品id
        "name": "Ruko F11GIM2",  // 商品显示的名称
        "description": "",       // 商品描述, 目前只在7天促销活动中使用
        "url": "/products/ruko-f11gim2",  // 商品链接
        "scene":"",             // 商品场景图，目前只在7天促销活动中使用  1200X850
        "img": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/ruko-f11gim2-01.jpg?v=1685088007&width=600", // 商品主图，各个活动都有用到
    },

    "f11gim": {
        "id": "7401063317673",
        "name": "Ruko F11GIM",
        "description": "",
        "url": "/products/ruko-f11gim",
        'scene':"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/lQDPJw1xYF1NrXDNAibNAwKw06ixdXzWOo0FNSFtN0CeAA_770_550.jpg?v=1698895316",
        // "scene":"https://cdn.shopifycdn.net/s/files/1/0582/6963/0633/files/RukoF11GIM2.jpg?v=1686646963&width=600",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-f11gim2-01_79d96c07-160d-49a8-9767-256c2de85a9e.jpg?v=1686277074&width=600",
    },

    "f7mini": {
        "id": "7409277468841",
        "name": "Bwine F7MINI",
        "description": "",
        "url": "/products/bwine-f7mini",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-F7MINI.jpg?v=1686294884&width=600",
    },

    "f7minise": {
        "id": "8310003761321",
        "name": "Bwine F7MINI SE",
        "description": "",
        "url": "/products/bwine-f7mini-se",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Bewine-drone-F7MINI-SE_1.webp?v=1730965905&width=300",
    },

    "f7gb2": {
        "id": "7521018380457",
        "name": "Bwine F7GB2",
        "description": "4K Camera with 3-Axis Gimbal",
        "url": "/products/bwine-f7gb2",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/f7gb2.webp?v=1694857584",
        "img": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/Bwine-f7gb2-01.jpg?v=1686294764&width=600",
    }, 

    "f11": {
        "id": "7401590587561",
        "name": "Ruko F11",
        "description": "",
        "url": "/products/ruko-f11",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-f11-2560_1.jpg?v=1686229651&width=600",
    }, 

    "f11mini": {
        "id": "7535012675753",
        "name": "Ruko F11MINI",
        "description": "2 Batteries for 60mins Flight Time",
        "url": "/products/ruko-f11mini",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/f11mini.webp?v=1695102575",
        "img": "https://www.ruko.net/cdn/shop/files/01-f11MINI.jpg?v=1686279131&width=600",
    },

    "f11pro": {
        "id": "7401143435433",
        "name": "Ruko F11PRO",
        "description": "4K UHD Camera",
        "url": "/products/ruko-f11pro",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/f11pro.webp?v=1695102143",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-f11pro-01.jpg?v=1685088051&width=600",
    },

    "f11pro2": {
        "id": "8283194687657",
        "name": "Ruko F11PRO 2",
        "description": "",
        "url": "/products/ruko-f11pro-2",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/F11-PRO2-1.webp?v=1727693563&width=600",
    },
  
    "g11mini": {
        "id": "7881822797993",
        "name": "Gleesfun G11MINI",
        "description": "",
        "url": "/products/gleesfun-g11mini",
        'scene':"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/1_51641abd-2fd2-4f9a-b2f2-b0aeae20a1d1.webp?v=1704881338",
        // "scene":"https://cdn.shopifycdn.net/s/files/1/0582/6963/0633/files/RukoF11GIM2.jpg?v=1686646963&width=600",
        "img": "https://cdn.shopifycdn.net/s/files/1/0582/6963/0633/files/Gleesfun-Drone-G11MINI-01.webp?v=1704955649&width=600",
    },
  
    "g11minise": {
        "id": "8433374625961",
        "name": "Gleesfun G11MINI SE",
        "description": "",
        "url": "/products/gleesfun-g11mini-se",
        'scene':"",
        "img": "https://www.ruko.net/cdn/shop/files/Glessfun-G11MINI-SE.webp?v=1741675135&width=300",
    },
  
    "g11pro": {
        "id": "8363071242409",
        "name": "Glessfun G11PRO",
        "description": "",
        "url": "/products/glessfun-g11pro",
        'scene':"",
        "img": "https://www.ruko.net/cdn/shop/files/Gleesfun_G11PRO.webp?v=1736756163&width=300",
    },
  
    "u11mini": {
          "id": "8176391979177",
          "name": "Ruko U11MINI",
          "description": "",
          "url": "/products/ruko-u11mini",
          "scene":"",
          "img": "https://www.ruko.net/cdn/shop/files/1_21e5ad9c-6298-438e-bbc4-306a4c88fff7.png?v=1719372059&width=713",
    },
  
    "u11mini 4k": {
          "id": "8453926650025",
          "name": "Ruko U11MINI 4K",
          "description": "",
          "url": "/products/ruko-u11mini-4k",
          "scene":"",
          "img": "https://www.ruko.net/cdn/shop/files/RukoU11MINI4K_…703-b3ea-14d7c9cd9361.webp?v=1742886045&width=300",
    },

    "u11pro": {
        "id": "7399503724713",
        "name": "Ruko U11PRO",
        "description": "4K UHD Camera",
        "url": "/products/ruko-u11pro",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/u11pro.webp?v=1695102362",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-u11pro-camera-drones-1.jpg?v=1684459165&width=600",
    },

    "u11s": {
        "id": "7655066632361",
        "name": "Ruko U11S",
        "description": "Ruko U11S GPS Drone with Camera",
        "url": "/products/ruko-u11-u11s",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/aaa.webp?v=1706863657",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-u11-1.jpg?v=1684399034&width=600",
    },

    "v11": {
        "id": "7581523804329",
        "name": "Veeniix V11",
        "description": "9800FT Real-time Transmission Distance",
        "url": "/products/veeniix-v11",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/v11.webp?v=1694766992",
        "img": "https://www.ruko.net/cdn/shop/files/veeniix-v11-01.jpg?v=1686739854&width=600",
    },

    "v11mini": {
        "id": "7398707658921",
        "name": "Veeniix V11MINI",
        "description": "v11mini",
        "url": "/products/veeniix-v11mini",
        "scene":"https://www.ruko.net/cdn/shop/files/Veeniix-v11mini-03_1.jpg?v=1686365753&width=600",
        "img": "https://www.ruko.net/cdn/shop/files/Veeniix-V11MINI-drone-001.jpg?v=1686217574&width=600",
    },

    "v11minise": {
        "id": "8347321630889",
        "name": "Veeniix V11MINI SE",
        "description": "V11MINI SE",
        "url": "/products/veeniix-v11mini-se",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/Veeniix-V11MINI-SE_2.webp?v=1734577337",
        "img": "https://www.ruko.net/cdn/shop/files/Veeniix-V11MINI-SE_1.webp?v=1734576911&width=493",
    },
  
    "v11pro": {
          "id": "8293166579881",
          "name": "Veeniix V11PRO",
          "description": "",
          "url": "/products/veeniix-v11pro",
          "scene":"",
          "img": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/Veeniix-V11PRO-drone-in-ruko.webp?v=1727172724",
    },

    "65w": {
        "id": "8251659419817",
        "name": "Ruko 65W USB",
        "description": "",
        "url": "/products/ruko-65w-usb-c-charger",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/01_d71294d6-543c-4315-96c7-6ae6e91be83a.png?v=1724817027&width=300",
    },

    "rk100": {
        "id": "8097957806249",
        "name": "Ruko RK100",
        "description": "",
        "url": "/products/ruko-rk100-100w-solar-panel",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/RukoRK100100WPortableSolarPanel.webp?v=1716201600&width=1346",
    },

    "rk200": {
        "id": "7401587179689",
        "name": "Ruko RK200",
        "description": "",
        "url": "/products/ruko-rk200-portable-solar-panel",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/RukoRK200PortableSolarPanel_1.jpg?v=1689935889&width=300",
    },

    "r111": {
        "id": "8107711234217",
        "name": "Ruko R111",
        "description": "",
        "url": "/products/ruko-r111-remote-id-module",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/333214.webp?v=1716280709&width=1346",
    },

    "r299": {
        "id": "8087706960041",
        "name": "Ruko R299",
        "description": "",
        "url": "/products/ruko-r299-portable-power-station",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko-R299-Portable-Power-Station.webp?v=1715398009&width=1100",
    },

    "q127": {
        "id": "8280760680617",
        "name": "Ruko Q127 Amphibious Remote Control Trucks",
        "description": "",
        "url": "/products/ruko-q127-amphibious-remote-control-trucks",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/00-Ruko-Q127_-Amphibious-Remote-Control-Trucks.webp?v=1727256183&width=1600",
    },

    "q150": {
        "id": "8204409962665",
        "name": "Ruko Q150 Amphibious RC Stunt Car",
        "description": "",
        "url": "/products/ruko-q150-amphibious-rc-stunt-car",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/RukoQ150AmphibiousRCStuntCar.webp?v=1723705778&width=2560",
    },

    "1561": {
        "id": "8468770816169",
        "name": "Ruko 1561",
        "description": "",
        "url": "/products/ruko-1561-remote-control-excavator",
        "scene":"",
        "img": "    https://www.ruko.net/cdn/shop/files/Ruko1561RCExcavator_8.webp?v=1743646357&width=300",
    },

    "1604": {
        "id": "8316058140841",
        "name": "Ruko 1604",
        "description": "",
        "url": "/products/ruko-1604-amphibious-remote-control-tank",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko1604AmphibiousRemoteControlTank_1.webp?v=1731653722&width=300",
    },

    "1661": {
        "id": "8204408914089",
        "name": "Ruko 1661",
        "description": "",
        "url": "/products/ruko-1661-remote-control-excavator",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/0002.jpg?v=1721374469&width=713",
    },

    "2370": {
        "id": "8223604113577",
        "name": "Veeniix 2370 Stunt Remote Control Car",
        "description": "",
        "url": "/products/veeniix-2370-stunt-remote-control-car",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/1_3821dc72-9425-4f34-add7-0857cd109100.jpg?v=1723183030&width=1600",
    },

    "3589": {
        "id": "8169788735657",
        "name": "Musical Cat",
        "description": "",
        "url": "/products/ruko-3589-musical-cat",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko3589MusicalCat_1.webp?v=1718781366&width=300",
    },
    
    "1088": {
        "id": "7399494090921",
        "name": "Ruko 1088",
        "description": "",
        "url": "/products/ruko-1088-large-smart-robots-for-kids",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko1088LargeSmartRobotsforKids.webp?v=1706864681&width=600",
    },

    "6088": {
        "id": "7401631318185",
        "name": "Ruko 6088",
        "description": "",
        "url": "/products/ruko-6088-smart-robot-toy-for-kids",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko6088ProgrammableSmartRobotforKids.webp?v=1706864837&width=600",
    },

    "8809": {
        "id": "8369245454505",
        "name": "Ruko 8809 RC Dinosaur Smart Robot",
        "description": "",
        "url": "/products/ruko-8809-rc-dinosaur-smart-robot",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko_8809_RC_dinosaur_smart_robot.webp?v=1737095108&width=300",
    },

    "18011": {
        "id": "8357548425385",
        "name": "Ruko 18011",
        "description": "",
        "url": "/products/ruko-18011-rc-robot-dog-toy",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Ruko18011robotdog_1.webp?v=1736143775&width=300",
    },

    "1601amp": {
        "id": "7649005535401",
        "name": "Ruko 1601AMP",
        "description": "",
        "url": "/products/ruko-1601amp-amphibious-rc-truck",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/ruko-1601amp-amphibious-rc-car-01.jpg?v=1688363189&width=600",
    },

    "v991": {
        "id": "7410031165609",
        "name": "Veeniix V991",
        "description": "",
        "url": "/products/veeniix-v991-transforming-rc-car",
        "scene":"",
        "img": "https://cdn.shopifycdn.net/s/files/1/0582/6963/0633/files/Veeniix_V991_Transforming_RC_Car_01.jpg?v=1696470839&width=1000",
    },

    "v992": {
        "id": "8231667564713",
        "name": "Veeniix V992",
        "description": "",
        "url": "/products/veeniix-v992-transform-remote-control-car",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/zhut_75cc862c-ffbf-4b75-a46f-c91502641962.jpg?v=1724146421&width=300",
    },

    "v994": {
        "id": "8341466611881",
        "name": "Veeniix V994",
        "description": "",
        "url": "/products/veeniix-v994-shooting-rc-stunt-car",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/VeeniixV994ShootingRCStuntCar_6.webp?v=1733996474&width=300",
    },

    "v998": {
        "id": "8351768936617",
        "name": "Veeniix V998",
        "description": "",
        "url": "/products/veeniix-v998-ejecting-rc-bumper-cars",
        "scene":"",
        "img": "https://www.ruko.net/cdn/shop/files/Veeniix-V998-e…ting-rc-bumpers-car_3.webp?v=1735194826&width=300",
    },
  
    "m3a1": {
        "id": "7410010456233",
        "name": "Bwine M3A1",
        "description": "",
        "url": "/products/bwine-m3a1-gel-blaster",
        "scene":"https://cdn.shopify.com/s/files/1/0582/6963/0633/files/M3A1_GEL_BLASTER-800X600_9af4e157-bd65-4c93-9998-887e9137c9f0.webp?v=1705659545",
        "img": "https://cdn.shopify.com/s/files/1/0582/6963/0633/files/Bwine-M3A1-GelBlaster-Guns_compressed.webp?v=1705660578",
    },
  
    "m4a1": {
        "id": "7649008418985",
        "name": "Bwine M4A1",
        "description": "",
        "url": "/products/bwine-m4a1-electric-gel-ball-blaster",
        "scene":"https://www.ruko.net/cdn/shop/products/bwine-m4a1-electric-gel-ball-blaster-09.jpg?v=1688636009&width=600",
        "img": "https://www.ruko.net/cdn/shop/files/bwine-m4a1-electric-gel-ball-blaster-01.jpg?v=1688636009&width=600",
    },
}

/********************************************************************************/

var this_year = new Date().getYear() + 1900;
console.log(this_year);
function convert_datetime_to_timestamp(datetime) {
    datetime = datetime.replace(" ", "T");
    let date = new Date(datetime);
    let timestamp = date.getTime() / 1000;
    // 获取当前时区偏移（单位：分钟）
    let timezone_offset = new Date().getTimezoneOffset();
  
    return timestamp - timezone_offset * 60 - 8 * 3600;
}


function set_now_time() {
    let now = Math.ceil(new Date().getTime() / 1000);

    let add_day = get_url_var('add_day');
    if (add_day) {
        now += add_day * 3600 * 24;
    }
    
    let add_hour = get_url_var('add_hour');
    if (add_hour) {
        now += add_hour * 3600;
    }
    
    let add_minute = get_url_var('add_minute');
    if (add_minute) {
        now += add_minute * 60;
    }
    
    return now;
}

function get_url_var(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
} 
